import { CatCard } from '@blocks-react/components/Card';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowForward } from '@blocks-react/components/Icons/ArrowForward';
import { useBreakpoint } from '../../../hooks';
import NoHtmlContent from '../../common/noHtmlContent/noHtmlContent';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import cx from 'classnames';
import styles from '../serviceRecommendation.module.scss';

type ServiceRecommendationCardsdProps = {
  title: string;
  impact: string;
  buttonText: string;
  handleModal: (cardInfo: object) => void;
  cardInfo: object;
};

export const ServiceRecommendationCards = ({
  title,
  impact,
  buttonText,
  handleModal,
  cardInfo
}: ServiceRecommendationCardsdProps) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  return (
    <CatCard
      className={cx(styles['service_card'], {
        'mb-3': !isMD,
        [styles['service_card_desktop']]: isMD
      })}
    >
      <CatHeading variant="label" className={styles['service_card_title']}>
        {title}
      </CatHeading>
      <CatHeading
        className={styles['service_card_description']}
        variant="footnote"
      >
        <NoHtmlContent content={impact} />
      </CatHeading>
      <div className={`${styles['service_card_border']} pt-1`}>
        <CatButton
          variant="ghost"
          size="sm"
          onClick={() => handleModal(cardInfo)}
          className={styles['service_card_view_button']}
          aria-label={buttonText}
        >
          {buttonText} <CatIconArrowForward slot="after" />
        </CatButton>
      </div>
    </CatCard>
  );
};
